<template>
    <div class="page place1">
      <borne-header></borne-header>

      <div class="content">
        <p>Borne N°{{borne_number}}</p>
        <div class="youtubeList">
          <a v-for="video in videos" :key="video.name" class="buttonLink youtubeLink" :href="video.link">{{video.name}}</a>
        </div>
        <router-link v-if="is_final_place" class="buttonLink buttonLink2" to="/LastPanel">Fin</router-link>
        <router-link v-else class="buttonLink buttonLink2" :to="{name: 'Geolocation', params: {place: next_place}}">Allez à la borne {{borne_number + 1}}</router-link>
      </div>
    </div>
</template>

<script>

import BorneHeader from "../components/BorneHeader"
import Links from '../components/links.js'

export default {
  name: 'home',
  components: {BorneHeader},
  data: () => ({
    target: null
  }),
  mounted: function() {
    this.target = window.localStorage.getItem('target');
  },
  computed: {
    videos: function() {return Links[this.target]},
    borne_number: function() {
      return this.target ? Number.parseInt(this.target.slice(5)) : '';
    },
    next_place: function() {
      return `place${this.borne_number + 1}`;
    },
    is_final_place: function() {
      return (!Links[this.next_place])
    }
  }
}

	
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
 $buttonLinkColor: #ED3B24;

 .place1 {

  .content, .youtubeList {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  p{
      font-size:150%;
      margin-bottom: 50px;
    }

  a {
    width: 70%;
  }

  @media only screen and (min-width: 500px) {

    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
      font-size: 3em;
    }

    h1 {
      text-align: center;
    }
    
    .borneheader {
      justify-content: center;
      margin: -60px 0 60px;
    }

  }
 }
 .borneheader{
   justify-content: flex-end;
   margin-top: 20px;
 }

</style>



// WEBPACK FOOTER //
// src/views/Place.vue